(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire.register("iE7OH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf; }, function (v) { return $0380ce8f1f064ccc$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0380ce8f1f064ccc$export$f7ad0328861e2f03; }, function (v) { return $0380ce8f1f064ccc$export$f7ad0328861e2f03 = v; });
var $0380ce8f1f064ccc$export$6503ec6e8aabbaf;
var $0380ce8f1f064ccc$export$f7ad0328861e2f03;
"use strict";
var $0380ce8f1f064ccc$var$mapping = {};
function $0380ce8f1f064ccc$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$0380ce8f1f064ccc$var$mapping[keys[i]] = pairs[keys[i]];
}
function $0380ce8f1f064ccc$var$resolve(id) {
    var resolved = $0380ce8f1f064ccc$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$0380ce8f1f064ccc$export$6503ec6e8aabbaf = $0380ce8f1f064ccc$var$register;
$0380ce8f1f064ccc$export$f7ad0328861e2f03 = $0380ce8f1f064ccc$var$resolve;

});

var $7ede88aee0c4af2b$exports = {};

(parcelRequire("iE7OH")).register(JSON.parse('{"7Vem4":"shopping-list.6889cc6c.js","8lVdV":"Yaroslav_Matvieiev.5d8f5fe2.jpg","dvJIi":"Denys_Lavryk.af261305.jpg","28vT0":"Anastasiia_Vedmid.6ca2fc2e.jpg","htewY":"Marina_Sihida.33350952.jpg","f6ubB":"Vitalii_Duduka.62284618.jpg","4PEBw":"Mary_Kuzo.54a21753.jpg","aqM5A":"Oleksii_Burlaka.0c514305.jpg","kuloD":"Victory_Krasova.9923d6fc.jpg","FsH2z":"Artem_Zaicew.b1be3a25.jpg","cSrA0":"Oleksii_Khodarchenko.d12245be.jpg","6wAZj":"oleg_kryuchkov.4f6bf2d5.jpg","iJ6vb":"save-children.4bc49885.png","agntg":"save-children-2x.344c3429.png","eHUIz":"project-hope.ee1dff41.png","7aCTR":"project-hope-2x.68dcba1c.png","c5wfK":"united24.09710d57.png","hJtLD":"united24-2x.49f947bd.png","7dWzA":"international-medical-corps.6d8da1c0.png","kIVln":"international-medical-corps-2x.78bf59d8.png","bUmjK":"medicins-sans-frontiers.69d60c87.png","tUS9z":"medicins-sans-frontiers-2x.d7188d89.png","efqG8":"razom.937888e8.png","hDgIJ":"razom-2x.13d5fee6.png","j1Ya2":"action-against-hunger.5d4e3dc5.png","6J1Be":"action-against-hunger-2x.ee0d520d.png","6z7Ny":"world-vision.c3b99688.png","jaW5E":"world-vision-2x.8fa48756.png","lfOYP":"sergiy-prytula.bfca1697.png","5sMXO":"sergiy-prytula-2x.84af21b4.png"}'));

})();
//# sourceMappingURL=shopping-list.7c9db318.js.map
